import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const STORAGE_KEY = 'rostery_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) !== 'accepted') setVisible(true);
    } catch {
      // localStorage unavailable (e.g. private mode) — show banner, just won't persist
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch {
      /* ignore persistence failure */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9000] p-3 sm:p-4 pointer-events-none">
      <div className="pointer-events-auto max-w-3xl mx-auto bg-white rounded-2xl border border-slate-200 shadow-lg p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <div className="w-9 h-9 rounded-lg bg-indigo-50 flex items-center justify-center shrink-0">
            <Cookie size={18} className="text-indigo-600" />
          </div>
          <p className="text-sm text-slate-600 leading-relaxed">
            We use cookies to keep you signed in and to improve Rostery. By continuing you agree to
            our use of cookies. See our{' '}
            <Link to="/privacy-policy" className="text-indigo-600 font-medium hover:underline">
              Privacy Policy
            </Link>
            .
          </p>
        </div>
        <button
          onClick={accept}
          className="shrink-0 text-sm font-semibold px-5 py-2.5 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition-colors"
        >
          Accept
        </button>
      </div>
    </div>
  );
}
